import API from "./api";
import API_ROUTES from "./apiRoutes";

export const getVisitorTypes = async () => {
  const res = await API.get(API_ROUTES.visitors.types);
  return res.data;
};

export const resolveResidentForUnit = async (unitId) => {
  const res = await API.get(API_ROUTES.visitors.resolveResident, {
    params: { unit_id: unitId },
  });
  return res.data;
};

export const createVisitorEntry = async (payload) => {
  const res = await API.post(API_ROUTES.visitors.entries, payload);
  return res.data;
};

const readListResponse = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.entries)) return data.entries;
  return [];
};

export const getGuardVisitorEntries = async ({ societyId, limit, offset } = {}) => {
  const res = await API.get(API_ROUTES.visitors.guardEntries, {
    params: {
      ...(societyId ? { society_id: societyId } : {}),
      ...(limit ? { limit } : {}),
      ...(offset ? { offset } : {}),
    },
  });
  return readListResponse(res.data);
};

export const checkInVisitorEntry = async (id) => {
  const res = await API.patch(API_ROUTES.visitors.checkIn(id));
  return res.data;
};

export const checkOutVisitorEntry = async (id) => {
  const res = await API.patch(API_ROUTES.visitors.checkOut(id));
  return res.data;
};

export const getResidentVisitorRequests = async ({ residentUserId, limit, offset } = {}) => {
  const res = await API.get(API_ROUTES.visitors.residentRequests, {
    params: {
      ...(residentUserId ? { user_id: residentUserId } : {}),
      ...(limit ? { limit } : {}),
      ...(offset ? { offset } : {}),
    },
    headers: residentUserId ? { "x-user-id": residentUserId } : undefined,
  });
  return readListResponse(res.data);
};

export const approveVisitorEntry = async (id, { residentUserId } = {}) => {
  const res = await API.patch(
    API_ROUTES.visitors.approve(id),
    {},
    {
      headers: residentUserId ? { "x-user-id": residentUserId } : undefined,
      params: residentUserId ? { user_id: residentUserId } : undefined,
    }
  );
  return res.data;
};

export const rejectVisitorEntry = async (
  id,
  { residentUserId, rejectionReason }
) => {
  const res = await API.patch(
    API_ROUTES.visitors.reject(id),
    { rejection_reason: rejectionReason },
    {
      headers: residentUserId ? { "x-user-id": residentUserId } : undefined,
      params: residentUserId ? { user_id: residentUserId } : undefined,
    }
  );
  return res.data;
};
